


import React, { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as authApi from "../api/authApi";
import * as teamApi from "../api/teamApi";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const AUTH_TOKEN_KEY = "token";
  const USER_DATA_KEY = "user";

  // ✅ SINGLE auth bootstrap
  useEffect(() => {
    try {
      const token = localStorage.getItem(AUTH_TOKEN_KEY);
      const userData = localStorage.getItem(USER_DATA_KEY);

      if (token && userData) {
        setUser(JSON.parse(userData));
      }
    } catch (err) {
      console.error("Auth bootstrap failed:", err);
      localStorage.clear();
    } finally {
      setLoading(false);
    }
  }, []);

  // 🔐 SIGN IN
  const signIn = async (credentials) => {
    const data = await authApi.login(credentials);

    if (data?.token && data?.user) {
      localStorage.setItem(AUTH_TOKEN_KEY, data.token);
      localStorage.setItem(USER_DATA_KEY, JSON.stringify(data.user));
      setUser(data.user);

      // ✅ ROLE-BASED REDIRECT
      if (data.user.role === "ADMIN") {
        navigate("/admin/dashboard", { replace: true });
      } else {
        navigate("/dashboard", { replace: true });
      }
    }
    return data;
  };

  // 📝 SIGN UP (USER only)
  const signUp = async (userData) => {
    const res = await authApi.register(userData);
    const data = res.data;

    if (data?.token && data?.user) {
      localStorage.setItem(AUTH_TOKEN_KEY, data.token);
      localStorage.setItem(USER_DATA_KEY, JSON.stringify(data.user));
      setUser(data.user);
      navigate("/dashboard", { replace: true });
    }
    return data;
  };

  // 👥 JOIN TEAM
  const joinTeamSession = async (payload) => {
    const data = await teamApi.joinTeam(payload);

    if (data?.token && data?.user) {
      localStorage.setItem(AUTH_TOKEN_KEY, data.token);
      localStorage.setItem(USER_DATA_KEY, JSON.stringify(data.user));
      setUser(data.user);
      navigate("/dashboard", { replace: true });
    }
    return data;
  };

  // 🚪 SIGN OUT
  const signOut = () => {
    localStorage.clear();
    setUser(null);
    navigate("/login", { replace: true });
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        signIn,
        signUp,
        joinTeamSession,
        signOut,
        isAuthenticated: !!user,
      }}
    >
      {!loading && children}
    </AuthContext.Provider>
  );
};
